/* eslint-disable react-hooks/exhaustive-deps */
import AppContext from "./AppContext";
import AppRoute from "./navigation/AppRoute";
import routesConfig from "./navigation/RoutesConfig";
import React from "react";

function App() {

  return (
    <AppContext.Provider value={routesConfig}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <AppRoute routes={routesConfig} />
      </React.Suspense>
    </AppContext.Provider >
  );
}

export default App;
